import React, { useState, useEffect } from 'react';

import {
  Container,
  Text,
  TextHighlight,
  SubTextWrapper,
  TextWrapper,
  SuccessFeedback,
} from './styles';
import { contato, phoneMask } from "../../utils/constants";
import QuestionForm from '../QuestionForm';

function QuestionsSection() {
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    if (submitted) {
      setInterval(() => {
        setSubmitted(false);
      }, 5000);
    }
  }, [submitted]);

  return (
    <Container>
      <Text bold>
        TEM MAIS DÚVIDAS SOBRE A{' '}
        <TextHighlight bold>PRECATÓRIOS BRASIL?</TextHighlight>
      </Text>
      <Text smallText>
        Envie suas dúvidas que entraremos em contato o mais breve possível
      </Text>
      <QuestionForm submitCallback={setSubmitted} />
      <Text smallText>
        Ficou com dúvidas sobre a Precatórios Brasil? Ligue para{" "}
        <TextHighlight smallText>{phoneMask(contato.telefoneComDDD)}</TextHighlight>
      </Text>
      <SuccessFeedback submitted={submitted}>
        <TextWrapper>
          <Text>OBRIGADO PELO ENVIO,</Text>
          <TextHighlight>EM BREVE ENTRAREMOS EM CONTATO!</TextHighlight>
        </TextWrapper>
        <SubTextWrapper>
          <Text smallText>
            Ficou com dúvidas sobre a Precatórios Brasil? Ligue para{" "}
            <TextHighlight smallText>{phoneMask(contato.telefoneComDDD)}</TextHighlight>
          </Text>
        </SubTextWrapper>
      </SuccessFeedback>
    </Container>
  );
}

export default QuestionsSection;
